import React, { useState } from "react";
import logo from './logo.svg';
import './App.css';

function App() {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const sendEmails = async () => {
    if (!file) {
      alert("Lütfen bir CSV dosyası seçin.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const uploadResponse = await fetch("http://localhost:5000/upload", {
        method: "POST",
        body: formData,
      });
      const uploadData = await uploadResponse.json();

      const response = await fetch("http://localhost:5000/send_bulk_email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject,
          body,
          file_path: uploadData.file_path,
        }),
      });

      const data = await response.json();
      setMessage(data.message);
    } catch (error) {
      setMessage("E-postalar gönderilemedi!");
    }
  };

  // **RETURN BURADA FONKSİYONUN İÇİNDE OLMALI!**
  return (
    <div style={{ padding: "20px" }}>
      <h1>Toplu Mail Gönderici</h1>
      <input
        type="text"
        placeholder="Konu"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        placeholder="Mesaj Gövdesi"
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={sendEmails}>E-postaları Gönder</button>
      <p>{message}</p>
    </div>
  );
}

export default App;

